export class SubscriptionModel {
    applicationId: string;
    userId: string;
    subscriptionDetail: string
}
